var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-contribute-activity',{attrs:{"preparatoryBackgroundImage":_vm.bgImage,"submissionBackgroundImage":_vm.bgImage,"votingBackgroundImage":_vm.bgVotingImage,"rankPath":"contribute-scorpio-rank","votesType":"20241201"}})}
var staticRenderFns = []

export { render, staticRenderFns }